<template>
  <el-dialog
    top="0"
    :title="type === 1?'各项支出明细编辑':type === 2?'全年应付编辑':'全年核定支出编辑'"
    :visible.sync="expenditureEditDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="1200px"
    center>

    <el-form :model="expenditureForm" ref="expenditureForm" label-position="left" label-width="40px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="社区">
            <el-input v-model="projectName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="小区">
            <el-input v-model="communityName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="年度">
            <el-input v-model="year" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="type === 1">
          <el-form-item label="月份">
            <el-select v-model="expenditureForm.month" placeholder="请选择月份" @change="monthChange" style="width: 100%;">
              <el-option
                v-for="item in monthList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-card class="box-card">
            <div class="flex align-center justify-between" slot="header">
              <span class="margin-right-xs">一、人工费</span>
              <el-input type="number" @input="setTotal" v-model="expenditureForm.num[0]" disabled>
                <template slot="append">元</template>
              </el-input>
            </div>
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">1、正式职工工资</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[1]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">2、正式职工保险、公积金</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[2]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">3、劳务派遣费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[3]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">4、劳务分包费（综合分包）</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[4]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">5、福利费（含体检费、防暑降温费）</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[5]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">6、劳动保护费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[6]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">7、其他费用</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[7]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card">
            <div class="flex align-center justify-between" slot="header">
              <span class="margin-right-xs">二、共用部位及共用设施设备的日常运行及维护费用</span>
              <el-input type="number" @input="setTotal" v-model="expenditureForm.num[8]" disabled>
                <template slot="append">元</template>
              </el-input>
            </div>
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">1、维修材料费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[9]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">2、供暖系统维保费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[10]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">3、电梯运行维保费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[11]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">4、空调系统维保费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[12]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">5、弱电系统维保费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[13]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">6、电梯检测费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[14]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">7、避雷检测费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[15]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">8、器具检测费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[16]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">9、水质化验及水箱清洗费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[17]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">10、设备保养、维修费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[18]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">11、设备设施采购费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[19]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">12、其它费用（设备设施相关）</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[20]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card">
            <div class="flex align-center justify-between" slot="header">
              <span class="margin-right-xs">三、物业管理区域安保相关费用</span>
              <el-input type="number" @input="setTotal" v-model="expenditureForm.num[21]" disabled>
                <template slot="append">元</template>
              </el-input>
            </div>
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">1、消防系统维护费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[22]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">2、消防设备设施采购费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[23]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">3、灭火器检测费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[24]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">4、安防系统维保费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[25]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">5、保安外包服务费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[26]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">6、安全防护用品</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[27]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">7、其它费用（安保相关）</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[28]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card">
            <div class="flex align-center justify-between" slot="header">
              <span class="margin-right-xs">四、物业管理区域餐饮管理相关费用</span>
              <el-input type="number" @input="setTotal" v-model="expenditureForm.num[29]" disabled>
                <template slot="append">元</template>
              </el-input>
            </div>
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">1、餐饮分包费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[30]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">2、原材料成本费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[31]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">3、其它费用</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[32]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="24">
          <el-card class="box-card">
            <div class="flex align-center justify-between" slot="header">
              <span class="margin-right-xs">五、物业管理区域保洁及绿化养护费用</span>
              <el-input type="number" @input="setTotal" v-model="expenditureForm.num[33]" disabled>
                <template slot="append">元</template>
              </el-input>
            </div>
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">1、保洁用品费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[34]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">2、保洁分包费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[35]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">3、灭虫消杀费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[36]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">4、外墙清洗费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[37]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">5、垃圾清运费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[38]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">6、垃圾分类</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[39]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">7、石材养护费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[40]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">8、化粪池清掏费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[41]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">9、绿植租摆费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[42]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">10、绿化养护费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[43]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">11、客户服务分包费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[44]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">12、其它费用</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[45]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card">
            <div class="flex align-center justify-between" slot="header">
              <span class="margin-right-xs">六、能源费</span>
              <el-input type="number" @input="setTotal" v-model="expenditureForm.num[46]" disabled>
                <template slot="append">元</template>
              </el-input>
            </div>
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">1、水费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[47]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">2、电费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[48]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">3、其他</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[49]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card">
            <div class="flex align-center justify-between" slot="header">
              <span class="margin-right-xs">七、公杂费</span>
              <el-input type="number" @input="setTotal" v-model="expenditureForm.num[50]" disabled>
                <template slot="append">元</template>
              </el-input>
            </div>
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">1、电话费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[51]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">2、办公用品</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[52]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">3、印刷标识费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[53]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>


              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">4、房屋租赁费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[54]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">5、车辆使用费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[55]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">6、咨询费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[56]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">7、其他费用</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[57]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>


            </el-row>
          </el-card>
          <el-card class="box-card">
            <div class="flex align-center justify-between" slot="header">
              <span class="margin-right-xs">八、其他</span>
              <el-input type="number" @input="setTotal" v-model="expenditureForm.num[58]" disabled>
                <template slot="append">元</template>
              </el-input>
            </div>
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">1、公共设施保险费</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[59]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">2、其他</span>
                  <el-input type="number" @input="setTotal" v-model="expenditureForm.num[60]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card" v-if="type === 1">
            <div class="flex align-center justify-between">
              <span class="margin-right-xs">九、税金</span>
              <el-input type="number" @input="setTotal" v-model="expenditureForm.num[61]">
                <template slot="append">元</template>
              </el-input>
            </div>
          </el-card>
          <el-card class="box-card" v-if="type === 1">
            <div class="flex align-center justify-between">
              <span class="margin-right-xs">十、上缴公司的管理费</span>
              <el-input type="number" @input="setTotal" v-model="expenditureForm.num[62]">
                <template slot="append">元</template>
              </el-input>
            </div>
          </el-card>
          <el-card class="box-card" v-if="type === 1">
            <div class="flex align-center justify-between">
              <span class="margin-right-xs">十一、处机关管理费</span>
              <el-input type="number" @input="setTotal" v-model="expenditureForm.num[63]">
                <template slot="append">元</template>
              </el-input>
            </div>
          </el-card>

        </el-col>
        <el-col :span="24" v-if="type === 1">
          <el-card class="box-card">
            <div class="flex align-center justify-between">
              <span class="margin-right-xs">十二、支出合计</span>
              <el-input type="number" @input="setTotal" v-model="expenditureForm.num[64]" disabled>
                <template slot="append">元</template>
              </el-input>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('expenditureForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('expenditureForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {monthList} from "@/utils/utils";
import {addMingXi, addQuanNianHeDingShouFu, addQuanNianYingShouFu, getOneMonthMingXi, getShuJuBiao} from "@/api/caiwu";

export default {
  name: "expenditureEditDialog",
  props: {
    expenditureEditDialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default() {
        return 0;
      }
    },
    year: {
      type: Number,
      default() {
        return 0;
      }
    },
    project: {
      type: Number,
      default() {
        return 0;
      }
    },
    projectName: {
      type: String,
    },
    community: {
      type: Number,
      default() {
        return 0;
      }
    },
    communityName: {
      type: String,
    }
  },
  data() {
    return {
      monthList: monthList,
      expenditureForm: {
        month: '',
        num: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      }
    }
  },
  created() {

  },
  components: {},
  methods: {


    //  获取收支明细
    async getInfo() {
      let _data = await getShuJuBiao(this.year, this.project, this.community)
      if (this.type === 2){
        let _arr = []
        _data.data[1].xiangmu_one.map((item,index)=>{
          if(index<this.expenditureForm.num.length){
            _arr.push(item.quanNianYingShou?item.quanNianYingShou:0)
          }
        })
        this.expenditureForm.num = _arr
      }
      if(this.type === 3){
        let _arr = []
        _data.data[1].xiangmu_one.map((item,index)=>{
          if(index<this.expenditureForm.num.length){
            _arr.push(item.heDingShouRu?item.heDingShouRu:0)
          }
        })
        this.expenditureForm.num = _arr
      }
    },


    async submitForm(formName) {
      if (!this.expenditureForm.month && this.type === 1) return this.$message.error('请选择月份')
      this.expenditureForm.num.map(item => {
        if (!item) item = 0
      })

      if (this.type === 1) {
        await addMingXi(this.project, this.community, this.year, this.expenditureForm.month, 2, this.expenditureForm.num.join(','))
      } else if (this.type === 2) {
        console.log(this.expenditureForm.num.join(','))
        console.log(this.expenditureForm.num.slice(0, -4).join(','))
        await addQuanNianYingShouFu(this.project, this.community, this.year, 2, this.expenditureForm.num.join(',').slice(0, -4))
      } else if (this.type === 3) {
        console.log(this.expenditureForm.num.join(','))
        console.log(this.expenditureForm.num.join(',').slice(0, -4))
        await addQuanNianHeDingShouFu(this.project, this.community, this.year, 2, this.expenditureForm.num.join(',').slice(0, -4))
      }
      this.$message.success('编辑成功')
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', false)
      this.expenditureForm.num = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      this.expenditureForm.month = ''
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.expenditureForm.num = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      this.expenditureForm.month = ''
      this.$emit('cancelDialog', false)
    },
    monthChange(e) {
      this.expenditureForm.month = e
      this.getOneMonthMingXi()
    },
    async getOneMonthMingXi() {
      let _arr = []
      let _data = await getOneMonthMingXi(this.project, this.community, this.year, this.expenditureForm.month, 2)
      _data.data[0].xiangmu_one.map((item, index) => {
        if (index <= (_data.data[0].xiangmu_one.length - 3))
          _arr.push(item.Yue)
      })
      this.expenditureForm.num = _arr
    },
    setTotal() {
      let _mode1 = 0
      let _arr1 = [1, 2, 3, 4, 5, 6, 7]
      _arr1.map(item => {
        _mode1 += Number(this.expenditureForm.num[item])
      })
      this.expenditureForm.num[0] = _mode1.toFixed(2)

      let _mode2 = 0
      let _arr2 = [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]
      _arr2.map(item => {
        _mode2 += Number(this.expenditureForm.num[item])
      })
      this.expenditureForm.num[8] = _mode2.toFixed(2)

      let _mode3 = 0
      let _arr3 = [22, 23, 24, 25, 26, 27, 28]
      _arr3.map(item => {
        _mode3 += Number(this.expenditureForm.num[item])
      })
      this.expenditureForm.num[21] = _mode3.toFixed(2)

      let _mode4 = 0
      let _arr4 = [30, 31, 32]
      _arr4.map(item => {
        _mode4 += Number(this.expenditureForm.num[item])
      })
      this.expenditureForm.num[29] = _mode4.toFixed(2)

      let _mode5 = 0
      let _arr5 = [34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45]
      _arr5.map(item => {
        _mode5 += Number(this.expenditureForm.num[item])
      })
      this.expenditureForm.num[33] = _mode5.toFixed(2)

      let _mode6 = 0
      let _arr6 = [47, 48, 49]
      _arr6.map(item => {
        _mode6 += Number(this.expenditureForm.num[item])
      })
      this.expenditureForm.num[46] = _mode6.toFixed(2)

      let _mode7 = 0
      let _arr7 = [51, 52, 53, 54, 55, 56, 57]
      _arr7.map(item => {
        _mode7 += Number(this.expenditureForm.num[item])
      })
      this.expenditureForm.num[50] = _mode7.toFixed(2)

      let _mode8 = 0
      let _arr8 = [59, 60]
      _arr8.map(item => {
        _mode8 += Number(this.expenditureForm.num[item])
      })
      this.expenditureForm.num[58] = _mode8.toFixed(2)

      let _total = 0
      this.expenditureForm.num[64] = 0
      let _arrAll = [..._arr1, ..._arr2, ..._arr3, ..._arr4, ..._arr5, ..._arr6, ..._arr7, ..._arr8]
      for (const key in this.expenditureForm.num) {
        if (_arrAll.indexOf(Number(key)) === -1) {
          _total += Number(this.expenditureForm.num[key])
        }
      }
      this.expenditureForm.num[64] = _total.toFixed(2)
    }
  },
  filters: {},
  watch: {
    type(){
      if (this.type === 2 || this.type === 3) {
        this.getInfo()
      }
    }
  },
}
</script>

<style scoped lang="scss">
.box-card {
  margin-bottom: 20px;

  .el-input {
    width: 180px;
  }
}
</style>

